import { trackError } from '@billy/track-error'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchCompanyOnboarding } from '../query-api'

export const useFetchCompanyOnboarding = () => {
  const { data, ...rest } = useQuery(QueryKeys.CompanyOnboarding, () => fetchCompanyOnboarding(), {
    onError: (error) => {
      trackError(error)
    },
    refetchOnMount: false,
  })

  return { onboarding: data?.data.onboarding, ...rest }
}
